import { Link } from 'react-router-dom';

function DropTrackAnalytics() {
    return (
        <div className="border rounded-lg border-[#EAEAEA] col-span-2 min-h-[55vh] py-5 flex flex-col gap-4">
            <div className="flex items-center justify-between px-4">
                <h1 className="font-semibold text-base">DropTrack Analytics</h1>

                <Link to='/droptrack-products' className="text-[#1055EB] font-semibold text-[12px] leading-6" href="/">View all</Link>
            </div>

            <div className="m-auto">
                <h1 className='font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            <div className="droptrack-products-list flex flex-col">
                {/* Map droptrack products. Slice for only top 5. Others can be viewed with view all link trigger */}
                {/* <DropTrackAnalyticsItem 
                    product={productInfo}
                />
                <DropTrackAnalyticsItem 
                    product={productInfo}
                />
                <DropTrackAnalyticsItem 
                    product={productInfo}
                />
                <DropTrackAnalyticsItem 
                    product={productInfo}
                />
                <DropTrackAnalyticsItem 
                    product={productInfo}
                /> */}
            </div>
        </div>
    );
}

export default DropTrackAnalytics;
